import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Hidden, Typography } from '@mui/material';
import GridContainer from '@jumbo/components/GridContainer';
import GridItem from '@jumbo/components/GridItem';
import useImage from 'services/Hooks/useImage';
import SkeletonWrapper from 'Components/SkeletonWrapper';
import ExteriorSignageQuoteUploadLogoSection from './ExteriorSignageQuoteUploadLogoSection';

const useStyles = makeStyles(theme => ({
  pageFull: {
    width: '100%',
    marginTop: '1vh',
  },
  noItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  totalInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-end',
    alignItems: 'flex-end',
  },
  borderDanger: {
    borderColor: theme.palette.danger.main,
  },
}));

const ExteriorSignageQuoteInfoCheckoutSection = ({ exteriorSignageQuote, isLoading, validator, isDisabled }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { getExteriorSignageImage } = useImage();

  return (
    <Box className={classes.pageFull}>
      {exteriorSignageQuote &&
        exteriorSignageQuote?.quoteItems?.map(item => (
          <GridContainer>
            <GridItem xs={12} md={2}>
              <Box className={classes.center}>
                <img
                  src={
                    item?.imgSrc
                      ? getExteriorSignageImage(item?.exteriorSignage_Id, item?.imgSrc.id)
                      : '/images/brp-logo.png'
                  }
                  alt="img"
                  style={{ maxWidth: '10vh', maxHeight: '10vh' }}
                />
              </Box>
            </GridItem>
            <GridItem xs={12} md={7}>
              <Typography variant="h2">{item.name}</Typography>
              <Typography variant="h5" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                {item?.sku}
              </Typography>
              <Divider sx={{ mt: 0 }} />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                <Box>
                  <Box>
                    <Typography variant="h2">{t('unitPrice')}</Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography fontSize={25} color={'text.primary'} fontWeight="bold">
                    ${item?.unitPrice?.toFixed(2)} {item.currencyName}
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ mt: 0, mb: item.unitPricePromotion !== item.unitPrice ? 2 : 0 }} />

              <Typography fontSize={15} color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                {t('exteriorSignageQuoteItemBrands', {
                  count: item.numberOfBrand,
                  numberOfBrand: item.numberOfBrand,
                })}
              </Typography>
            </GridItem>
            <GridItem xs={12} md={3} sx={{ alignSelf: 'center' }}>
              <Box fontSize={20} display="flex" justifyContent={'center'} alignItems={'center'}>
                <Box>
                  <Typography variant="h2">{t('quantity')}</Typography>
                </Box>
              </Box>
              <Box display="flex" justifyContent={'center'} alignItems={'center'}>
                <Typography variant="h1">{item.quantity}</Typography>
              </Box>
            </GridItem>
            <GridItem xs={12}>
              <Divider />
            </GridItem>
          </GridContainer>
        ))}
      {!exteriorSignageQuote ||
        (exteriorSignageQuote.quoteItems?.lenght <= 0 && (
          <Box className={classes.noItem}>
            <Typography fontSize={20} color="text.secondary" sx={{ mt: 1, mb: 1 }}>
              {t('NoItemInExteriorSignageQuote')}
            </Typography>
          </Box>
        ))}
      <SkeletonWrapper
        skeletonProps={{
          width: 210,
          height: 33,
        }}
        isLoading={isLoading}
        component={
          <Box className={classes.totalInfo} sx={{ mt: 2 }}>
            <Typography variant="h1">${(exteriorSignageQuote?.total ?? 0).toFixed(2)}</Typography>
          </Box>
        }
      />
      <Hidden mdDown>
        <ExteriorSignageQuoteUploadLogoSection
          exteriorSignageQuote={exteriorSignageQuote}
          isDisabled={isDisabled}
          isLoading={isLoading}
          validator={validator}
        />
      </Hidden>
    </Box>
  );
};

export default ExteriorSignageQuoteInfoCheckoutSection;
